export default __webpack_public_path__ + "static/media/1212.fa907270.png";